/*
 * @Auther: 罗耀祖
 * @Date: 2021-08-11 09:38:34
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-17 15:36:04
 * @name: 入口文件
 * @Description: 入口文件
 * @FilePath: \project\src\entrance.js
 * @Author: DESKTOP-1QU67QM
 */
import router from './router'
import userStorage from '@/storage/user.storage'; //cookie对象

const whiteList = ['/login', '/register', '/registerSuccess', '/forgetPassword', '/updatePassword']; //不需要token

router.beforeEach(async(to, from, next) => {
  const token = new userStorage().token;
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      next();
    }
  } else {
    // 没有token未登录
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login`);
    }
  }
})